import {isNotNullOrUndefined} from '../helper/TypeHelper';

export default {
    AMBIGUOUS_AIRLINES: [
        {
            title: 'SunExpress Deutschland',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um SunExpress Deutschland handelte, nicht um SunExpress Türkei. Sie erkennen Flüge von SunExpress Deutschland daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'SunExpress Türkei',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um SunExpress Türkei handelte, nicht um SunExpress Deutschland. Sie erkennen Flüge von SunExpress Türkei daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'Eurowings',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um Eurowings handelte, nicht um Eurowings Europe oder Lufthansa. Sie erkennen Flüge von Eurowings daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'Eurowings Europe',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um Eurowings Europe handelte, nicht um Eurowings oder Lufthansa. Sie erkennen Flüge von Eurowings Europe daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'Lufthansa',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um Lufthansa handelte, nicht um Lufthansa Cityline, Eurowings oder Eurowings Europe. Sie erkennen Flüge von Lufthansa daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'EasyJet',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um EasyJet handelte, nicht um EasyJet Europe oder EasyJet Switzerland. Sie erkennen Flüge von EasyJet daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'EasyJet Switzerland ',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um EasyJet Switzerland handelte, nicht um EasyJet Europe oder EasyJet. Sie erkennen Flüge von EasyJet Switzerland daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'Iberia',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um Iberia handelte, nicht um Iberia Express oder Air Nostrum. Sie erkennen Flüge von Iberia daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'Air Nostrum',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um Air Nostrum handelte, nicht um Iberia Express oder Iberia. Sie erkennen Flüge von Air Nostrum daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'KLM Royal Dutch Airlines',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um KLM handelte, nicht um KLM Cityhopper. Sie erkennen Flüge von KLM daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'KLM Cityhopper',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um KLM Cityhopper handelte, nicht um KLM. Sie erkennen Flüge von KLM Cityhopper daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'Corendon Dutch Airlines',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um Corendon Dutch Airlines handelte, nicht um Corendon Airlines oder Corendon Airlines Europe. Sie erkennen Flüge von Corendon Dutch Airlines daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'Corendon Airlines',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um Corendon Airlines handelte, nicht um Corendon Dutch Airlines oder Corendon Airlines Europe. Sie erkennen Flüge von Corendon Airlines daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'Lufthansa CityLine',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um Lufthansa CityLine handelte, nicht um Lufthansa. Sie erkennen Flüge von Lufthansa CityLine daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'TUI/TUIfly',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um TUI/TUIfly handelte, nicht um TUI Airlines Netherlands oder TUI Airlines Belgium. Sie erkennen Flüge von TUI/TUIfly daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'TUI Airlines Nederland',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um TUI Airlines Nederland handelte, nicht um TUI/TUIfly oder TUI Airlines Belgium. Sie erkennen Flüge von TUI Airlines Nederland daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'TUI Airlines Belgium',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um TUI Airlines Belgium handelte, nicht um TUI/TUIfly oder TUI Airlines Nederland. Sie erkennen Flüge von TUI Airlines Belgium daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'TAP Portugal',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um TAP Portugal handelte, nicht um Portugalia Airlines. Sie erkennen Flüge von TAP Portugal daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'Portugalia Airlines',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um Portugalia Airlines handelte, nicht um TAP Portugal. Sie erkennen Flüge von Portugalia Airlines daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'Air Canada',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um Air Canada handelte, nicht um Air Canada Rouge. Sie erkennen Flüge von Air Canada daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'Air Canada Rouge',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um Air Canada Rouge handelte, nicht um Air Canada. Sie erkennen Flüge von Air Canada Rouge daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'Laudamotion',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um Laudamotion handelte, nicht um Ryanair. Sie erkennen Flüge von Laudamotion daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'Ryanair',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um Ryanair handelte, nicht um Laudamotion. Sie erkennen Flüge von Ryanair daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'fly2sky',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um fly2sky handelte, nicht um Go2Sky. Sie erkennen Flüge von fly2sky daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'Go2Sky',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um Go2Sky handelte, nicht um fly2sky. Sie erkennen Flüge von Go2Sky daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'SWISS',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um SWISS handelte, nicht um Edelweiss Air. Sie erkennen Flüge von SWISS daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        },
        {
            title: 'Edelweiß Air',
            message: 'Bitte stellen Sie sicher, dass es sich bei der ausführenden Fluglinie um Edelweiß Air handelte, nicht um SWISS. Sie erkennen Flüge von Edelweiß Air daran, dass ihre Flugnummern mit folgenden Buchstaben beginnen: '
        }
    ],
    getAirlineMessageByTitle(title)
    {
        let message = null;

        let airline = this.AMBIGUOUS_AIRLINES.find(airline => airline.title === title);

        if (isNotNullOrUndefined(airline))
            message = airline.message;

        return message;
    }
};